import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import { Typography } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import { useTranslate } from "../../hooks/useTranslate";
import BaseDialog from "../BaseDialog";
import axiosManager from "../../services/axiosManager";
import { useStudents } from "../../context/students";
import useStatuses from "../../context/status/useStatuses";
import "./LockingConfirmationDialog.css";

const LockingConfirmationDialog = (props) => {
    const { isOpen, setIsOpen } = props;
    const { t } = useTranslate();
    const { activeStudentId } = useStudents();
    const { refetchGeneralStatuses } = useStatuses();

    const {
        mutateAsync: completeEnrolment,
        isPending: isCompleting,
    } = useMutation({
        mutationFn: () => axiosManager.post$(`/parent/api/students/${activeStudentId}/enrolment-details/complete`)
            .then((response) => response?.data),
        onSuccess: () => {
            refetchGeneralStatuses();
            setIsOpen(false);
        },
    });

    return (
        <BaseDialog
            isWide
            open={isOpen}
            title={t("lockingConfirmation.title")}
            className="locking-confirmation-dialog p-4"
        >
            <Typography variant="body1" component="div">
                {t("lockingConfirmation.subtitle")}
            </Typography>
            <div className="w-full flex align-center gap-8 mt-8">
                <Button
                    variant="contained"
                    className="button-accent w-full"
                    onClick={completeEnrolment}
                    loading={isCompleting}
                >
                    {t("lockingConfirmation.progressBtn")}
                </Button>
                <Button
                    variant="outlined"
                    className="button-primary w-full"
                    onClick={() => setIsOpen(false)}
                    disabled={isCompleting}
                >
                    {t("lockingConfirmation.reviewBtn")}
                </Button>
            </div>
        </BaseDialog>
    );
};

export default LockingConfirmationDialog;
